import React, { useState, useContext } from 'react';
import { WebsiteContext } from '../../context/WebsiteProvider';
import reciprocalIconOn from '../../assets/icons/recipToggleOn.png'; // Adjust paths
import reciprocalIconOff from '../../assets/icons/recipToggleOff.png';
import reciprocalIconOffLightMode from '../../assets/icons/recipToggleOffLightMode.png';

const TeamSearch = ({ onAgentSelect, reciprocalAllowed, darkMode = false }) => {
  const { searchResults, fetchAgentInfo, reciprocal, setReciprocal } = useContext(WebsiteContext);
  const [inputValue, setInputValue] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    if (newValue) {
      const isReciprocal = reciprocalAllowed ? reciprocal : false;
      fetchAgentInfo(newValue, isReciprocal);
      setIsDropdownOpen(true);
    } else {
      setIsDropdownOpen(false);
    }
  };

  const handleSelectAgent = (agent) => {
    onAgentSelect(agent);
    setInputValue('');
    setIsDropdownOpen(false);
  };

  const toggleReciprocal = () => {
    const newReciprocalState = !reciprocal;
    setReciprocal(newReciprocalState);
    if (inputValue.trim()) {
      fetchAgentInfo(inputValue, newReciprocalState);
    }
  };

  const getIcon = () => {
    return reciprocal ? reciprocalIconOn : darkMode ? reciprocalIconOff : reciprocalIconOffLightMode;
  };

  return (
    <div className="relative">
      <input
        className="w-full p-2 border rounded dark:bg-stone-800 dark:text-gray-300 dark:border-stone-700 pr-10"
        type="text"
        placeholder={
          reciprocalAllowed && reciprocal
            ? 'Search for Reciprocal Agents'
            : 'Search for Agents'
        }
        value={inputValue}
        onChange={handleInputChange}
      />
      {reciprocalAllowed && (
        <button
          onClick={toggleReciprocal}
          className={`absolute inset-y-0 right-0 m-1 flex items-center rounded border border-gray-400 px-1 dark:border-stone-500 ${
            reciprocal ? 'bg-gray-200 dark:bg-stone-700' : 'bg-gray-300 dark:bg-stone-500'
          }`}
          title={
            reciprocal
              ? 'Switch to Non-Reciprocal Agents'
              : 'Switch to Reciprocal Agents'
          }
        >
          <img src={getIcon()} alt="Toggle Reciprocal" className="h-5 w-5" />
        </button>
      )}
      {isDropdownOpen && searchResults.length > 0 && (
        <div
          className="absolute mt-1 w-full bg-white border rounded shadow-lg z-50 dark:bg-stone-800 dark:border-stone-700 dark:text-gray-300"
          style={{ maxHeight: '200px', overflowY: 'auto' }}
        >
          {searchResults.map((result, index) => (
            <div
              key={index}
              className="p-2 hover:bg-gray-100 cursor-pointer dark:hover:bg-stone-600"
              onClick={() => handleSelectAgent(result)}
            >
              {`${result.firstName} ${result.lastName}`}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TeamSearch;